/**
 * Guarantees that the function provided executes only once.
 * Subsequent calls to the returned function will return the same value as the first call.
 *
 * ## Example
 * Perform a browser user-agent check only once.
 * ```javascript
 * const isFacebookApp = _once(() => {
 *   const ua = navigator.userAgent || navigator.vendor;
 *   return ua ? (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1) : false;
 * });
 * ```
 *
 * @param fn The function to execute.
 */
export function _once<T extends (...args: any[]) => any>(fn: T): T {
	let res: unknown
	let called = false
	return ((...args: any[]) => {
		if (called) return res
		called = true
		res = fn(...args)

		// Nullify reference to the original function as it is no longer required (allows for GC)
		fn = undefined

		return res
	}) as T
}
